"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Editions = require("self-service-api/constants/Editions");

var _NonMerchandiseIdIdentifers = require("pricing-pages-unified-ui/constants/NonMerchandiseIdIdentifers");

// These are used ONLY to attach to nodes for acceptance test purposes
var _default = function _default(isInMCBeta) {
  var _ref, _ref2;

  return isInMCBeta ? (_ref = {}, (0, _defineProperty2.default)(_ref, _Editions.STARTER, _NonMerchandiseIdIdentifers.GROWTH_SUITE_STARTER_MC), (0, _defineProperty2.default)(_ref, _Editions.PROFESSIONAL, _NonMerchandiseIdIdentifers.GROWTH_SUITE_PROFESSIONAL_MC), (0, _defineProperty2.default)(_ref, _Editions.ENTERPRISE, _NonMerchandiseIdIdentifers.GROWTH_SUITE_ENTERPRISE_MC), _ref) : (_ref2 = {}, (0, _defineProperty2.default)(_ref2, _Editions.STARTER, _NonMerchandiseIdIdentifers.GROWTH_SUITE_STARTER), (0, _defineProperty2.default)(_ref2, _Editions.PROFESSIONAL, _NonMerchandiseIdIdentifers.GROWTH_SUITE_PROFESSIONAL), (0, _defineProperty2.default)(_ref2, _Editions.ENTERPRISE, _NonMerchandiseIdIdentifers.GROWTH_SUITE_ENTERPRISE), _ref2);
};

exports.default = _default;
module.exports = exports.default;